require("./jquery.bxslider");
import Accordion from "./accordion";


Drupal.behaviors.header_search = {
  attach: function (context, settings) {
    if (context.body != undefined) { // is context html element
      var trigger = jQuery('.js--search-trigger');
      if (!trigger.length) {
        return;
      }

      var $body = jQuery('body');
      var searchField = document.querySelector('.form-search');
      var $wrapper = jQuery('.js--header-search')

      $body.on('click', function(event) {
        if (event.target != trigger[0] && event.target != searchField) {
          $wrapper.removeClass('is-active');
        }
        else if (trigger[0].contains(event.target) || event.target === trigger[0]) {
          $wrapper.toggleClass('is-active');
          setTimeout(function(){
            searchField.focus();
          }, 100);
        }
      });
    }
  }
}



Drupal.behaviors.imageCropped = {
  attach: function(context, settings) {
    if (context.body != undefined) { // is context html element
      var $elements = jQuery('.js--image-cropped');
      if (!$elements.length) {
        return;
      }

      $elements.each(function (index, element) {
        var $element, $img, _src;
        $element = jQuery(element);
        $img = $element.find('img');
        _src = $img.attr('src');
        $element.css({
          "background-image": 'url(' + _src + ')'
        });
        return $img.css({
          visibility: "hidden"
        });
      });
    }
  }
}


Drupal.behaviors.slider = {
  attach: function (context, settings) {
    if (context.body != undefined) { // is context html element
      $('.carousel').bxSlider({
        pager: true,
        pagerType: 'short',
        easing: 'linear',
        adaptiveHeight: true,
        nextText: 'weiter',
        prevText: 'zurück',
        touchEnabled: false,
        auto: true,
        autoHover: true,
      });
    }
  }
};


Drupal.behaviors.exposed_tabs = {
  attach: function (context, settings) {
    if (context.body != undefined) { // is context html element
      var $wrapper = jQuery('.js--exposed-tabs');
      if (!$wrapper.length) {
        return;
      }
      var $trigger = $wrapper.find('.views--exposed-tabs-trigger')
      $trigger.on('click', function(event) {
        $wrapper.toggleClass('show-items');
      });
    }
  }
};

Drupal.behaviors.accordion = {
  attach: function (context, settings) {
    new Accordion('.js--accordion');
  }
}


Drupal.behaviors.cookie_compliance = {
  attach: function (context, settings) {
    setTimeout(() => {
      const scripts = document.querySelectorAll('script[type="text/plain"].eu-cookie-target');
      if (Drupal.eu_cookie_compliance && Drupal.eu_cookie_compliance.hasAgreedWithCategory("tracking")) {
        for (let index = 0; index < scripts.length; index++) {
          const script = scripts[index];
          script.removeAttribute('type');
        }
      }
    }, 1);
  }
}



// WEBPACK FOOTER //
// ./src/js/index.js